export class SslCertificateError extends Error {
    public constructor() {
        super('SSL certificate error');

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, SslCertificateError.prototype);
    }
}
